/**
 * Muse S template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Muse S";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
};

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

jQuery(function($){
	jQuery(document).ready(function(){
	  $(".muse-s-page").css("padding-top",$(".header").height());
	  if(parseInt($(".muse-s-page").css("padding-top")) != $(".header").height()){
		// $(".muse-s-page").css("padding-top",$(".header").height());
	  }
	  setTimeout(function(){
		if(parseInt($(".muse-s-page").css("padding-top")) != $(".header").height()){
		//   $(".muse-s-page").css("padding-top",$(".header").height());
		}
	  }, 2500);
	  $(window).on('resize', function(){
		if(parseInt($(".muse-s-page").css("padding-top")) != $(".header").height()){
		//   $(".muse-s-page").css("padding-top",$(".header").height());
		}
	  });
	  
	  $(window).scroll(function() {
		if(parseInt($(".muse-s-page").css("padding-top")) != $(".header").height()){
		  $(".muse-s-page").css("padding-top",$(".header").height());
		}
	  });
	  // step wrapper slider
	  // hero image transition
  
	  if ($('.hero-bg-slider').length > 0) {
		var scrollDownArrow = function() {
		  $(".hero-section .scroldown .btn-down img").css({"animation":"wheel 2s ease-in-out","-webkit-animation":"wheel 2s ease-in-out"});
		  setTimeout(function(){
			$(".hero-section .scroldown .btn-down img").css({"animation":"none","-webkit-animation":"none"});
		  }, 2000);
		}
  
		var handleHeroSlides = function() {
		  $(".hero-section").addClass("dark-theme"); 
		  scrollDownArrow();
		  setTimeout(function(){
			$(".hero-section").removeClass("dark-theme");
			scrollDownArrow();
		  }, 7000);
		}
  
		setTimeout(function(){
		  handleHeroSlides();
		}, 7000);
  
		setInterval(handleHeroSlides, 14000);
  
	  }
  
	  $('a.goto').on("click",function(e){
		var t = $(this).attr("data-target");
		if($(t).length>0){
		  $("html, body").animate({
			  scrollTop:$(t).offset().top - $(".header").height()
		  },2000)
		}
	  });
	  function detect_visibility(element){
		var top_of_element = $(element).offset().top - 100;
		var bottom_of_element = $(element).offset().top + $(element).outerHeight();
		var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
		var top_of_screen = $(window).scrollTop();
		if (($(window).scrollTop() > top_of_element)){
		  if(window.scrollY==0){
			jQuery("header").removeClass("floated");
		  }
		  else{
			jQuery("header").addClass("floated");
		  }
		} 
		else {
		  jQuery("header").removeClass("floated");
		}
	  }
	  $(window).scroll(function() {
		detect_visibility(".band-features");
	  });
	  detect_visibility(".band-features");
  
	  // band-features
	  jQuery(function($){
		if (($(window).scrollTop() > $(".band-features .img-wrapper").offset().top - 100)){
		  if(window.scrollY==0){
			
		  }
		  $(".band-features .img-wrapper").addClass("scrolled");
		}
		$(window).scroll(function() {
		  if (($(window).scrollTop() > $(".band-features .img-wrapper").offset().top - $(".band-features .img-wrapper").outerHeight() + 250)){
			if(window.scrollY==0){
			  $(".band-features .img-wrapper").removeClass("scrolled");
			}
			$(".band-features .img-wrapper").addClass("scrolled");
		  }
		  else{
			// $(".band-features .img-wrapper").removeClass("scrolled");
		  }
		})
	  })
  
	  // reviews slider
	  if ($('.reviews .review-wrapper').length > 0) {
		var handleReviewsSlides = function() {
		  if ($('.reviews .review-wrapper').hasClass('slick-initialized')) {
			$('.reviews .review-wrapper').slick('unslick');
		  }
		  if ($(window).width() > 992) {
			$('.reviews .review-wrapper').slick({
			  slidesToShow: 3,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: true,
			  arrows: true,
			  draggable: false
			});
		  }
		  else{
			$('.reviews .review-wrapper').slick({
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: true,
			  arrows: true,
			  draggable: false
			});
		  }
		};
  
		handleReviewsSlides();
		$(window).on('resize', function(){
		  setTimeout(function(){
			handleReviewsSlides();
		  }, 100);
		});
	  }
  
	  function pauseAllAudio() {
		const allAudio = document.getElementsByTagName("audio");
		for (singleAudio of allAudio) {
		  singleAudio.pause();
		}
		$(".playIcon").removeClass("hide");
		$(".pauseIcon").addClass("hide");
		
	  }
  
	  var myAudio = document.getElementById("myAudio");
  
	  function togglePlay() {
		if(myAudio.paused){
		  pauseAllAudio();
		  myAudio.play();
		  $("#audioPlayBtn .pauseIcon").removeClass("hide");
		  $("#audioPlayBtn .playIcon").addClass("hide");
		}
		else{
		  myAudio.pause();
		  $("#audioPlayBtn .playIcon").removeClass("hide");
		  $("#audioPlayBtn .pauseIcon").addClass("hide");
		  $('#audioPlayBtn').addClass('stopped');
		}
	  };
	  $("#audioPlayBtn").on('click', function(){
		togglePlay();
	  });
  
	  
	  // 6 audio sample play/pause logic
	  var audio_samples = document.querySelectorAll(".audio-sample-section .audio-play-button");
	  for (var i = 0; i < audio_samples.length; i++) {
		audio_samples.item(i).onclick = function() {
		  var currentAudio = this.closest("div").getElementsByTagName("audio")[0];
		  if(currentAudio.paused){
			pauseAllAudio();
			this.closest("div").getElementsByTagName("audio")[0].play();
			this.querySelector(".playIcon").classList.add("hide");
			this.querySelector(".pauseIcon").classList.remove("hide");
		  }
		  else{
			pauseAllAudio();
			this.closest("div").getElementsByTagName("audio")[0].pause();
			this.querySelector(".playIcon").classList.remove("hide");
			this.querySelector(".pauseIcon").classList.add("hide");
			this.classList.add('stopped');
		  }
		}
	  }
  
	  // mind graph video show
	  $(".mind-graph-video-wrapper").on('click', function(){
		$(this).find(".thumb").css('opacity','0');
		$(this).find("video").addClass("show");
		$(this).find("video").trigger('play');
		pauseAllAudio();
		if($(".mind-graph-video-wrapper").find("video").paused) {
		  $(".mind-graph-video-wrapper").find("video").play();
		}
	  });
  
	  // Muse Background Video Play when comes in view and pause at end for 7s
  
	  $('.audio-demo-section .text-wrapper').each(function(){  
		var highestBox = 0;
		$('p', this).each(function(){
		  if($(this).height() > highestBox) {
			highestBox = $(this).height(); 
		  }
		});
		$('p',this).height(highestBox);
	  }); 
	  $(window).on('resize', function(){
		$('.audio-demo-section .text-wrapper').each(function(){  
		  var highestBox = 0;
		  $('p', this).each(function(){
			if($(this).height() > highestBox) {
			  highestBox = $(this).height(); 
			}
		  });
		  $('p',this).height(highestBox);
		}); 
	  });
  
	  
	  document.getElementById('museBgVideo').pause();
	  document.getElementById('museBgVideoMobile').pause();
  
	  var videoPlayed = 0;
	  var audioDemoSecAnimation = function() {
		if (($(window).scrollTop() > ($(".audio-demo-section").offset().top - $(".audio-demo-section").outerHeight() + 400))){
		  if ($(window).width() > 767){
			
			document.getElementById('museBgVideo').play();          
			jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.first .progress-fill').css('animation','progress-forward 15s linear forwards');
  
			if(videoPlayed == 0){
			  setTimeout(function(){
				$(".audio-demo-section .text-wrapper").addClass("light-bg");
				jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.second .progress-fill').css('animation','progress-forward 6s linear forwards');
			  }, 15000);
			}
		  }
		  if ($(window).width() < 766){
			document.getElementById('museBgVideoMobile').play();
			jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.first .progress-fill').css('animation','progress-forward 15s linear forwards');
			// console.log("first started");
  
			if(videoPlayed == 0){
			  setTimeout(function(){
				$(".audio-demo-section .text-wrapper").addClass("light-bg");
				jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.second .progress-fill').css('animation','progress-forward 6s linear forwards');
				// console.log("second started 0");
			  }, 15000);
			}
		  }
  
		  if(videoPlayed == 1){
			jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.first .progress-fill').css('animation','progress-forward 15s linear forwards');
			// console.log("first started 1");
			setTimeout(function(){
			  $(".audio-demo-section .text-wrapper").addClass("light-bg");
			  jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.second .progress-fill').css('animation','progress-forward 6s linear forwards');
			  // console.log("second started 1");
			}, 15100);
		  }
		} 
	  }
	  audioDemoSecAnimation();
	  
	  $(window).scroll(function() {
		if(document.getElementById('museBgVideo').paused){
		  audioDemoSecAnimation();
		}
		if(document.getElementById('museBgVideoMobile').paused){
		  audioDemoSecAnimation();
		}
	  });
  
	  document.getElementById('museBgVideo').addEventListener('ended',myHandler,false);
	  document.getElementById('museBgVideoMobile').addEventListener('ended',myHandler,false);
	  function myHandler(e) {
		e.target.pause();
		
		setTimeout(function(){
		  e.target.play();
		  $(".audio-demo-section .text-wrapper").removeClass("light-bg");
		  jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.first .progress-fill').css('animation','');
		  jQuery('.audio-demo-section .progress-bar-wrapper .progress-bar.second .progress-fill').css('animation','');
		  videoPlayed = 1;
		  audioDemoSecAnimation();
		}, 7000);
	  }
  
	  // as-seen-on slider
	  if ($('.as-seen-on .content-wrapper').length > 0) {
		var handleAsSeenOnSlides = function() {
		  if ($('.as-seen-on .content-wrapper').hasClass('slick-initialized')) {
			$('.as-seen-on .content-wrapper').slick('unslick');
		  }
		  if ($(window).width() > 992) {
			$('.as-seen-on .content-wrapper').slick({
			  slidesToShow: 3,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: true,
			  arrows: true,
			  draggable: false
			});
		  }
		  else{
			$('.as-seen-on .content-wrapper').slick({
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  dots: false,
			  infinite: true,
			  arrows: true,
			  draggable: false
			});
		  }
		};
  
		handleAsSeenOnSlides();
		$(window).on('resize', function(){
		  setTimeout(function(){
			handleAsSeenOnSlides();
		  }, 100);
		});
	  }
  
	  if ($('.order-wrapper .slider-lg').length > 0) {
		$('.order-wrapper .slider-lg').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  dots: false,
		  infinite: true,
		  speed: 800,
		  arrows: true,
		  fade: true,
		  draggable: false,
		  asNavFor: '.order-wrapper .slider-sm',
		});
	  }
  
	  if ($('.order-wrapper .slider-sm').length > 0) {
		$('.order-wrapper .slider-sm').slick({
		  slidesToShow: 5,
		  slidesToScroll: 1,
		  dots: false,
		  arrows: false,
		  focusOnSelect: true,
		  asNavFor: '.order-wrapper .slider-lg'
		});
	  }
  
	  var remain_bv = 599;
	  function parseTime_bv(timestamp) {
		if (timestamp < 0) timestamp = 0;
  
		var day = Math.floor((timestamp / 60 / 60) / 24);
		var hour = Math.floor(timestamp / 60 / 60);
		var mins = Math.floor((timestamp - hour * 60 * 60) / 60);
		var secs = Math.floor(timestamp - hour * 60 * 60 - mins * 60);
		var left_hour = Math.floor((timestamp - day * 24 * 60 * 60) / 60 / 60);
  
		// $('span.afss_day_bv').text(day);
		// $('span.afss_hours_bv').text(left_hour);
  
		if (String(mins).length > 1)
		  $('span.afss_mins_bv').text(mins);
		else
		  $('span.afss_mins_bv').text("0" + mins +" :");
		if (String(secs).length > 1)
		  $('span.afss_secs_bv').text(secs);
		else
		  $('span.afss_secs_bv').text("0" + secs);
  
	  }
  
	  var $element = $('.order-section .content-side');
	  let counter = 0;
	  if ($element.length > 0) {
		$(window).scroll(function() {
		  var scroll = $(window).scrollTop() + $(window).height();
		  var offset = $element.offset().top
  
		  if (scroll > offset && counter == 0) {
			setInterval(function() {
			  remain_bv = remain_bv - 1;
			  parseTime_bv(remain_bv);
			  if (remain_bv <= 0) {
				return false;
			  }
			}, 1000);
			counter = 1;
		  }
		});
	  }
  
	  // buy button override based on url 
	  function updateQueryStringParameter(uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
		  return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
		  return uri + separator + key + "=" + value;
		}
	  }
	  if (window.location.href.indexOf("discount") > -1) {
		$.urlParam = function(name){
		  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  
		  return results[1] || 0;
		}
		const discount = $.urlParam('discount').split('?')[0];
		let old_link_src = jQuery("#btn-order-now").attr("href");
		jQuery("#btn-order-now").attr("href",updateQueryStringParameter(old_link_src, "discount",discount));
	  }
  
	  window.dataLayer = window.dataLayer || [];
	  $(document).on('afterChange', '.review-wrapper', function(){
		window.dataLayer.push({
		  event: 'reviewsCarouselChange'
		})
	  });
  
	  $(document).on('afterChange', '.content-wrapper', function(){
		window.dataLayer.push({
		  event: 'asSeenOnCarouselChange'
		})
	  });
  
	  var shortestImg = function(el){
		var lastSegment = el.split("/").pop();
		if(lastSegment.indexOf('?') > 0){
			return lastSegment.substring(0, lastSegment.indexOf('?'));
		}
		else{
			return lastSegment;
		}
	  }
  
	  $(document).on('afterChange', '.slider-lg', function(event, slick, currentSlide){
		var curr = $('.slider-lg').find('[data-slick-index="'+currentSlide+'"]');
  
		var currentSlideImg = shortestImg($(curr).find("img").attr("src"));
		var slideParameters = 'Carousel Image | Position ' + currentSlide + ' | ' + currentSlideImg;
  
		window.dataLayer.push({
		  event: 'productCarouselChange',
		  currentSlide: currentSlide,
		  slideParameters: slideParameters
		});
	  });
  
	  $(document).on('click', '.faq-section [data-toggle="collapse"].collapsed', function(e){
		var click_text = $(this).closest('button').text();
		window.dataLayer.push({
		  event: 'faqAccordionOpen',
		  accordionTitle: click_text.trim()
		});
	  });
  
	  $(document).on('click', '.audio-sample-section .audio-play-button:not(.stopped), #audioPlayBtn:not(.stopped)', function(){
		window.dataLayer.push({
		  event: 'audioSamplePlayed',
		  audioTitle: $(this).text().trim()
		});
	  });
	  
	});
  
  });

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
